module.exports = "<app-posting-ui id=\"container\"  *ngIf=\"this.playerModel != null\" [isPhonePosting]=\"true\" [canvasKey]=\"canvasKey\" ></app-posting-ui>"